import React from "react";

import { Grid } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import Button from '@mui/material/Button';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Box from '@mui/material/Box';
import CancelIcon from '@mui/icons-material/Cancel';
import Image from "../../utils/image";
import ImageViewer from "../../utils/image-viewer"
import Style from "../../../styles/js/Styles";
import { Range } from "../../../plas/utils/times/models"

import service from '../../../plas/services/ads/service';

export default function AdvertisementView({
	advertisement,
	fullWidth,
	onClose
}) {

	const theme = createTheme({
	  palette: {
	    primary: {
	      main: '#FFFFFF',
	      darker: '#FFFFFF',
	    }
	  },
	});

	const [blobUrl, setBlobUrl] = React.useState(null);

	const closeImage = () => {
		setBlobUrl(null);
	}

	const style = Style();

	const ColoredLine = ({ color }) => (
	    <hr
	        style={{
	            color: color,
	            backgroundColor: color,
	            marginTop: 6,
	            marginBottom: 6,
	            height: 2
	        }}
	    />
	);

	return(
 		<Grid container>
	 		<Grid item xs={false} md={ fullWidth ? false : 2} />
	       	<Grid item xs={12} md={ fullWidth ? 12 : 8} >
	       		<Grid container spacing={2}>
	       			<Grid item xs={12}>
						<p style={{ fontSize: '28px', textAlign: 'left'}}>
							{advertisement.title}
						</p>
						<ColoredLine color="gray"/>
					</Grid>
					<Grid item xs={12} style={{textAlign: 'right'}}>
						<i style={{color: 'gray', fontSize: 16}}>{ new Range(advertisement.startDate, advertisement.endDate).asDateText() }</i>
					</Grid>
					<Grid item xs={12}>
						<span style={{ fontSize: 17}}>{advertisement.body}</span>
					</Grid>
					{ advertisement.url && (
						<Grid item xs={12}>
							<a href={advertisement.url}>Ver más información</a>
						</Grid>)
					}
					<Grid item xs={12} style={{textAlign: 'right'}}>
						<b>{advertisement.place.name}</b>
						<br/>
						<span style={{color: 'gray', fontSize: 16}}>{advertisement.place.address}</span>
					</Grid>
					{ advertisement.binId && (
						<Grid item xs={12}>
							<Box
							  display="flex"
							  justifyContent="center"
							  alignItems="center"
							  width="100%">
								<Card elevation={0}>
	                                <Image 
										onClick={(url) => { setBlobUrl(url) }}
	                                  	url={service.api.advertisements.getMediaUrl(advertisement.id,advertisement.binId)} 
	                                  	containerProps={{style:{ width: '90%'}}}
	                                  	imgProps={{ className: style.selectable, style:{ width: "100%", maxHeight: 500, height: "auto", objectFit: 'contain'}}}/>
	                              </Card>
							</Box>
						</Grid>)
					}
					{ onClose && (
						<Grid item xs={12}>
							<ColoredLine color="gray"/>
							<Grid container spacing={2}>
								<Grid item xs={true}/>
								<Grid item>
									<ThemeProvider theme={theme}>
										<Button 
							            	startIcon={<CancelIcon/>} 
							            	variant="contained" 
							            	onClick={() => onClose()}>
							            	Cerrar
							            </Button>
							        </ThemeProvider>
								</Grid>
							</Grid>
						</Grid>)
					}
		       	</Grid>
	       	</Grid>
	   		<Grid item xs={false} md={ fullWidth ? false : 2} />
			<ImageViewer maxHeight='80vh' open={blobUrl? true : false} url={blobUrl} onClose={closeImage} />

		</Grid>
	)

}
